import baseTemplate from './pdp-info-tabs.html';

export default baseTemplate;
